"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityLink = exports.EntityLinkDefaultProps = exports.linkTargetPropsFromOpenGraph = exports.linkConversationTargetPropsFromSlug = exports.linkTargetPropsFromSlug = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var link_1 = require("../elements/link");
var entity_type_for_1 = require("../../utils/entity-type-for");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var linkTargetPropsFromSlug = function (_a) {
  var entity = _a.entity,
    definition = _a.definition;
  return {
    to: definition.to(entity.slug)
  };
};
exports.linkTargetPropsFromSlug = linkTargetPropsFromSlug;
var linkConversationTargetPropsFromSlug = function (_a) {
  var entity = _a.entity,
    definition = _a.definition;
  return {
    to: definition.to(entity.slug, 'conversation')
  };
};
exports.linkConversationTargetPropsFromSlug = linkConversationTargetPropsFromSlug;
var linkTargetPropsFromOpenGraph = function (_a) {
  var entity = _a.entity,
    definition = _a.definition;
  return entity.openGraph && entity.openGraph.url && {
    to: entity.openGraph.url
  } || (0, exports.linkTargetPropsFromSlug)({
    entity: entity,
    definition: definition
  });
};
exports.linkTargetPropsFromOpenGraph = linkTargetPropsFromOpenGraph;
exports.EntityLinkDefaultProps = {
  targetProps: exports.linkTargetPropsFromSlug
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &:hover .shp-cell-label {\n      color: ", ";\n    }\n  "], ["\n    &:hover .shp-cell-label {\n      color: ", ";\n    }\n  "])), theme_1.theme.COLOR('primary'))
});
var NonLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(link_1.Link)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  NonLink: styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), NonLinkStyles)
};
var EntityLink = function (props) {
  var className = props.className,
    entity = props.entity,
    children = props.children,
    inverted = props.inverted,
    stopPropagation = props.stopPropagation,
    targetProps = props.targetProps;
  var entityTypeName = (0, entity_type_for_1.entityTypeFor)(entity) || props.entityTypeName;
  if (!entityTypeName) {
    throw new Error("Cannot determine entity type name for entity ".concat(entity.name));
  }
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  if (!definition) {
    return null;
  }
  // console.log(entity);
  if (!entity.isReadable) {
    // shouldn't link
    return react_1.default.createElement(My.NonLink, {
      className: "shp-entity-link ".concat(className)
    }, children || entity.name);
  }
  var linkProps = targetProps({
    entity: entity,
    definition: definition
  });
  return react_1.default.createElement(My.Container, __assign({
    stopPropagation: stopPropagation,
    inverted: inverted
  }, linkProps, {
    className: "shp-entity-link ".concat(className)
  }), children || entity.name);
};
exports.EntityLink = EntityLink;
exports.EntityLink.defaultProps = exports.EntityLinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;